import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import { DamsColors } from "../styles/DamsColors";
import { TableHeaderLabel } from "./TableHeaderLabel";
import { DamsTableHead } from "./TableHead";
import { DamsTableRow, TRowItem } from "./TableRow";
import { DamsTableProps } from ".";
import { Stack } from "@mui/material";
import { OutlinedButton } from "../Button/AppButton";
import { DamsAppAsset } from "../../assets/registry";
import { Pagination } from "./PaginationLabel";

export function createData(data: Record<string, any>) {
  return data;
}

export default function DamsTable({
  tableTitle,
  tableSubtitle,
  tableTitleBadge = "",
  useTableCheckbox = false,
  tableHeaders,
  tableKeys,
  hiddenKeys,
  hiddenLabels,
  data,
  maxRowCells = 5,
  selectedRowItems = [],
  onTableItemEdit,
  onTableItemDelete,
  onTableItemSelect,
  extraRowComponent,
  hasPagination = false,
  onPreviousPage,
  onNextPage,
  paginationState,
  setActivePage,
  toggleSelectAllRow,
  headerDropDownMenu,
  hasHeaderCheckBox,
  isModel=false,

}: Readonly<DamsTableProps>) {

  const allItemsSelected = selectedRowItems.length === data?.length && data.length > 0
  const styles=getStyles(isModel);
  const isSelected = (row: TRowItem): boolean => !!selectedRowItems?.some((item) => item.id === row.id); 
  const hasItemsSelected =selectedRowItems.length > 0 ;

  return (
    <Box sx={{ ...styles.container, ...(hasPagination ? { height: "calc(100% - 105px)" } : {}) }}>
      {tableTitle !== "" && tableTitle && (
        <Box height={70} sx={styles.fixedBox}>
          <TableHeaderLabel
            title={tableTitle}
            subTitle={tableSubtitle}
            tableTitleBadge={`${tableTitleBadge}`}
            rowSelected={hasItemsSelected}
            headerDropDownMenu={headerDropDownMenu}
          />
        </Box>
      )}

      <TableContainer
       component={isModel ?Box: Paper}
        sx={styles.tableContainer}
      >
        <Table stickyHeader aria-label="collapsible table">
          <DamsTableHead
            TColumns={tableHeaders}
            selectTableItems={toggleSelectAllRow}
            hasItemsSelected={hasItemsSelected}
            allItemsSelected={allItemsSelected}
            maxHeaderItems={maxRowCells}
            hasCheckBox={useTableCheckbox}
            hasHeaderCheckBox={hasHeaderCheckBox}
            
          />

          <TableBody>
            {data?.map((row, index) => (
              <DamsTableRow
                TRowItem={row}
                onItemDelete={onTableItemDelete}
                onItemEdit={onTableItemEdit}
                toggleSelection={onTableItemSelect}
                isSelected={isSelected(row)}
                maxRowCells={maxRowCells}
                key={`tr-${row.cell_1}-${index}`}
                hasCheckBox={useTableCheckbox}
                TableKeys={tableKeys}
                HiddenKeys={hiddenKeys}
                HiddenLabels={hiddenLabels}
                extraRowComponent={extraRowComponent}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Stack
        height={hasPagination ? 60 : 0}
        sx={styles.fixedButtonBox}
        direction={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
        px={2}
      >
        {hasPagination && (
          <>
          <Box minWidth={130}>
          <OutlinedButton
              iconPosition="left"
              title="Previous"
              btnIconSrc={DamsAppAsset.icons.arrow_left_icon}
              onClick={onPreviousPage }
              loading={paginationState?.processing?.previous}
            />
          </Box>
    

            <Stack direction={"row"} gap={0.2} >
              <Pagination
                numberOfPages={paginationState?.total_pages??1}
                activePage={paginationState?.current_page??1}
                setActivePage={setActivePage}
                queryPage={paginationState?.processing?.pageNumber}
                
              />
            </Stack>
            <Box minWidth={90}>
            <OutlinedButton
              iconPosition="right"
              title="Next"
              btnIconSrc={DamsAppAsset.icons.arrow_right_icon}
              onClick={onNextPage}
              loading={paginationState?.processing?.next}
            />
            </Box>
        
          </>
        )}
      </Stack>
    </Box>
  );
}

const getStyles =(isModel:boolean)=>{ 
    return{
  container: {
    height: "calc(100% - 75px)",
  },
  fixedBox: {
    border: `1px solid ${DamsColors.Border.FooterDivider}`,
    borderRadius: "8px",
    borderBottom: "none",
  },
  fixedButtonBox: {
    border: isModel ? 'none':`1px solid ${DamsColors.Border.FooterDivider}`,
    borderRadius:isModel? 'none': "8px",
    BorderTop: "none",
  },
  tableContainer: {
    borderRadius:isModel?'none': "8px",
    border: isModel? 'none': `1px solid ${DamsColors.Border.FooterDivider}`,
    overflow: "auto",
    "&::-webkit-scrollbar": {
      display: "none",
    },
    msOverflowStyle: "none",
    scrollbarWidth: "none",
    height: "calc(100% - 65px)",
  },
}};
